"use client";

import {
  LeftRailNavigationNested,
  LeftRailNavigationFlat,
} from "@/components/LeftRailNavigation";
import { getHrefFromCustomUrlPlugin } from "@/helpers";
import { CustomUrl } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { Blocks, BuilderBlock } from "@builder.io/sdk-react";
// import { useRouter } from "next/navigation";
import { FC } from "react";

type Props = {
  navType: "flat" | "nested";
  navItemsHeadline?: string;
  navItems: {
    id: string;
    name: string;
    href: CustomUrl;
    dlt: string;
    dld: string;
    subItems?: {
      name: string;
      href: CustomUrl;
      dlt: string;
      dld: string;
    }[];
    blocks: BuilderBlock[];
  }[];
} & BuilderProps;

export const OnPageRailNavigationBlock: FC<Props> = ({
  navItems,
  navItemsHeadline,
  navType,
  builderBlock,
  builderComponents,
  builderLinkComponent,
}) => {
  // const router = useRouter();

  const navItemsWithHref = navItems.map((item) => ({
    name: item.name,
    href: getHrefFromCustomUrlPlugin(item.href || `#${item.id}`),
    dlt: item.dlt,
    dld: item.dld,
    subItems:
      item.subItems?.map((subItem) => ({
        name: subItem.name,
        href: getHrefFromCustomUrlPlugin(subItem.href),
        dlt: subItem.dlt,
        dld: subItem.dld,
      })) || [],
  }));

  const navItemsChildren = navItems.map((navItem, index) => (
    <Blocks
      parent={builderBlock?.id}
      registeredComponents={builderComponents}
      path={`navItems.${index}.blocks`}
      blocks={navItem.blocks}
      linkComponent={builderLinkComponent}
      key={navItem.id}
      className="min-w-0"
    />
  ));

  const blocksCount = navItemsChildren.reduce(
    (acc, child) => acc + (child?.props?.blocks?.length || 0),
    0,
  );

  return navType === "flat" ? (
    <LeftRailNavigationFlat
      navItemsHeadline={navItemsHeadline}
      navItems={navItemsWithHref}
      onMobileNavChange={(value: string) => {
        // router.push preserves state, resulting in two `main` elements
        // see https://nextjs.org/docs/app/guides/preserving-ui-state
        // wait until Next provides opt-out strategies
        // router.push(value);
        location.href = value;
      }}
    >
      {blocksCount > 0 ? navItemsChildren : undefined}
    </LeftRailNavigationFlat>
  ) : (
    <LeftRailNavigationNested
      navItemsHeadline={navItemsHeadline}
      navItems={navItemsWithHref}
    >
      {blocksCount > 0 ? navItemsChildren : undefined}
    </LeftRailNavigationNested>
  );
};
